__turbopack_context__.v({
  "gradient": "FSHokW_gradient",
  "gradientLeft": "FSHokW_gradientLeft",
});
